import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IOptionalFee } from "./optionaltype";

export const FETCH_OPTIONAL_FEE_PROGRESS = "FETCH_OPTIONAL_FEE_PROGRESS";
export const FETCH_OPTIONAL_FEE_SUCCESS = "FETCH_OPTIONAL_FEE_SUCCESS";
export const FETCH_OPTIONAL_FEE_FAILED = "FETCH_OPTIONAL_FEE_FAILED";

export const fetchOptionalFeeProgress = () =>
  action(FETCH_OPTIONAL_FEE_PROGRESS);

export const fetchOptionalFeeSuccess = (data: IOptionalFee[]) =>
  action(FETCH_OPTIONAL_FEE_SUCCESS, {
    data,
  });
export const fetchOptionalFeeFailed = () => action(FETCH_OPTIONAL_FEE_FAILED);

export const fetchOptionalFeeAsync =
  (
    // date: IDataTableV2DateState["dates"],
    organizations_uuid: string,
    statusss: string,
    courses_uuid?: string,
    batch?: string,
    acedmicYear?: number,
    fee_type?: string,
    is_optinal?: boolean,
    customer_fact_uuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchOptionalFeeProgress());

      let url = "";
      if (statusss) {
        url += `&status=${statusss}`;
      }
      if (organizations_uuid) {
        url += `&organizations_uuid=${organizations_uuid}`;
      }
      if (courses_uuid) {
        url += `&courses_uuid=${courses_uuid}`;
      }
      if (batch) {
        url += `&batch=${batch}`;
      }
      if (acedmicYear) {
        url += `&academic_year=${acedmicYear}`;
      }
      if (is_optinal) {
        url += `&is_optional=${is_optinal}`;
      }
      if (customer_fact_uuid) {
        url += `&customer_fact_uuid=${customer_fact_uuid}`;
      }
      if (fee_type) {
        url += `&column=fee_type&value=${encodeURIComponent(fee_type)}`;
      }

      // if (fee_type) {
      //   url += `&value=${encodeURIComponent(fee_type)}`;
      // }

      const res = await api.get(`master/get-optional-assigned-fee?` + url);

      const data: IOptionalFee[] = res.data.data;

      dispatch(fetchOptionalFeeSuccess(data));
    } catch (error: any) {
      dispatch(fetchOptionalFeeFailed());
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_OPTIONAL_FEE_STATE = "CLEAR_OPTIONAL_FEE_STATE";
export const CLEAR_OPTIONAL_FEE_TYPE = "CLEAR_OPTIONAL_FEE_TYPE";

export const clearOptionalFeeState = () => action(CLEAR_OPTIONAL_FEE_STATE);
export const clearOptionalFeeType = () => action(CLEAR_OPTIONAL_FEE_TYPE);
